import React from "react";
import { useSelector } from "react-redux";
import TabSelection from "../../components/SelectContent/TabSelection";

import { setSpectatorTab } from "../../state/slices/generalSlice";
import SpectateTRLocal from "./SpectateTRLocal";
import SpectateCos from "./SpectateCos";
import SpectateCwa from "./SpectateCwa";
import SpectateFsr from "./SpectateFsr";

import { CarFilled, CarryOutOutlined, FileDoneOutlined, FileTextOutlined } from "@ant-design/icons";
import { isFsrSpectatablePosition } from "../../utils/generalUtils";

const SpectatorPage = () => {
  const { spectator_accesses } = useSelector(
    (state) => state.accountDetailSlice.details,
  );

  // A grant's scope only matters for Dean positions (the only ones that
  // span both worlds) — "ao" excludes FSR, "facsec" excludes TRL/COS/CWA,
  // and "both" (the default, including every non-Dean grant) covers both.
  const hasFacultyAccess = (spectator_accesses || []).some(
    (item) =>
      isFsrSpectatablePosition(item?.approver_position) &&
      item?.scope !== "ao"
  );

  const hasAoAccess = (spectator_accesses || []).some(
    (item) => item?.scope !== "facsec"
  );

  const menuItems = [
    ...(hasAoAccess ? [{
      key: "tr-local",
      label: "Local Travel Request",
      component: <SpectateTRLocal />,
      icon: <CarFilled />,
    }] : []),
    ...(hasAoAccess ? [{
      key: "cos",
      label: "Certificate of Service",
      component: <SpectateCos />,
      icon: <CarryOutOutlined />,
    }] : []),
    ...(hasAoAccess ? [{
      key: "cwa",
      label: "Certificate of Work Accomplishment",
      component: <SpectateCwa />,
      icon: <FileDoneOutlined />,
    }] : []),
    ...(hasFacultyAccess ? [{
      key: "fsr",
      label: "Faculty Service Record",
      component: <SpectateFsr />,
      icon: <FileTextOutlined />,
    }] : []),
  ];

  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="spectatorCurrentTab"
        setTabAction={setSpectatorTab}
      />
    </>
  );
};

export default SpectatorPage;
